<template>
    <div>
        <v-card >
            <v-card-title class="blue_corp white--text">AJUSTE MANUAL</v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-sheet rounded="xl" style="border:1px solid lightgrey">
                                    <v-container>                                                                        
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <h5>Seleciona Producto</h5>
                                                <v-row class="mt-0">
                                                    <v-col cols="12" md="6">
                                                        <v-text-field id="barr"  label="Codigo Barra"
                                                            @change="captureBarra_v2(barra)" class='text-caption'
                                                            @keypress="onlyNumber" v-model="barra" dense outlined>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-divider vertical color="indigo" class="my-5"></v-divider>
                                            <v-col cols="12" md="6">
                                                <h5>Lista de Productos</h5>
                                                <v-row class="mt-0">
                                                    <v-col cols="4" md="6">
                                                        <v-btn class="mt-1" @click="d_inventa=true" small color="indigo" dark rounded>
                                                            <v-icon small>find_replace</v-icon>
                                                            <span class="text-btn">Selecciona Producto</span>
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <v-alert class='text-caption' v-if="existe=='si'" dense text type="success">
                                                            Existe !
                                                        </v-alert>
                                                        <v-alert class='text-caption' v-else-if="existe=='no'" dense text type="warning">
                                                            no Existe !
                                                        </v-alert>
                                                        <v-alert class='text-caption' v-else dense text type="info">
                                                            <span class="text-caption grey--text">Sku: 99999</span>
                                                        </v-alert>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>                            
                        </v-row>
                        <v-row class="mt-n2">
                            <v-col cols="8" md="3">
                                <v-text-field class='text-caption' v-model="sku" label="SKU" disabled filled outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-text-field class='text-caption' v-model="nombre" label="Nombre Producto" disabled filled outlined dense ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field class='text-caption' v-model="categoria" label="Categoria" disabled filled outlined dense ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n10">
                            <v-col cols="12" md="6">
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-textarea rows="5" class='text-caption' no-resize outlined v-model="descripcion" label="Descripcion" disabled filled></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row class="mt-n3">
                                    <v-col cols="12" md="8">
                                        <v-text-field class='text-caption' v-model="caracteristica" label="Caracteristica" outlined dense disabled filled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field class='text-caption' v-model="medida" label="Medida" outlined dense disabled filled></v-text-field>
                                        <!-- <v-text-field class='text-caption' v-model="preciolocal" label="Precio" outlined dense disabled filled></v-text-field> -->
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1">
                                    <v-col cols="12" md="6" class="mt-n6">
                                        <v-select class='text-caption' v-on:change="totalStock(bodega)" v-model="bodega" :items="listabodega" label="Bodega" item-text="nombre" item-value="id" :hint="tStock" persistent-hint dense outlined :disabled="disabledDatos" :filled="filledDatos"></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4" class="mt-n6">
                                        <v-text-field v-if="medida=='UN'" class='text-caption' @keypress="onlyNumber" v-model="cantidad" label="Cantidad" outlined dense clearable :disabled="disabledDatos" :filled="filledDatos"></v-text-field>
                                        <v-text-field v-else class='text-caption' @keypress="onlyDecimal" v-model="cantidad" label="Cantidad" outlined dense clearable :disabled="disabledDatos" :filled="filledDatos"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1">
                                    <v-col cols="12" md="4" class="mt-n6">
                                        <v-select class='text-caption' v-model="movimiento" :items="listamovimiento" label="I / E" dense outlined :disabled="disabledDatos" :filled="filledDatos"></v-select>
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-n6">
                                        <v-text-field class='text-caption' v-model="observa" label="Observacion" outlined dense :disabled="disabledDatos" :filled="filledDatos"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions style="margin-top:-40px">
                <v-spacer></v-spacer>
                <v-btn @click="clsInput()" small color="teal" dark rounded><v-icon small>add_circle</v-icon><span class='text-btn'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nuevo&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></v-btn>
                <v-btn v-if="disabledDatos!=true" @click="saveStock()" class="ml-5" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Grabar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></v-btn>
                <v-btn v-else class="ml-5" small color="grey" dark rounded><v-icon small>save</v-icon><span class='text-btn'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Grabar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></v-btn>
            </v-card-actions>
        </v-card>

        <!-- dialog inventa --> 
        <v-dialog v-model="d_inventa" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_inventa=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleInventa" dense dark :search="inventasearch" :headers="inventatitulo" :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="inventapage" :length="inventapageCount"  :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import axios from 'axios';
export default {
    name:'Manual',  
    components:{dialogo, snack}, 
    props: ['usu','contrato'], 
    data(){
        return{
            //contrato:'123',
            tStock:'',
            nStock:'',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            disabledBodega:false,
            filledBodega:false,
            disabledSku:false,
            filledSku:false,
            disabledDatos:true,
            filledDatos:true,
            existe:'',
            listabodega:[],
            sku:'',
            nombre:'',
            categoria:'',
            ncategoria:0,
            descripcion:'',
            caracteristica:'',
            cantidad:'',
            bodega:'',
            preciolocal:'',
            observa:'',
            dateHoy: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            listamovimiento:['Ingreso','Egreso'],
            movimiento:'',
            medida:'',
            d_inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'iSku', width:'' },
                { text: 'Producto', align: 'start', sortable: true, value: 'iProducto' },
                { text: 'Medida', align: 'start', sortable: true, value: 'iMedida' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 10,
            barra:'',
        }
    },
    async mounted(){
        this.loading=true;
        await this.searchBodegas();
        await this.buscarProducto();
        await this.focusBarra();
        this.loading=false;
    },
    methods:{
        focusBarra(){
            var elemento = document.getElementById("barr");
            elemento.focus();
            document.getElementById("barr").innerText='';
            document.getElementById("barr").value='';
            this.barra=''
            //elemento.blur();
        },
        captureBarra_v2(codBarra){
            if(this.barra.trim()!=''){
                let resultado;
                if(!isNaN(this.barra)){ // es numero
                    resultado = this.inventalista.filter( datos => parseInt(datos.barraSku) == parseInt(codBarra) );
                } else { // no es numero
                    resultado = this.inventalista.filter( datos => datos.barraSku == codBarra );
                };
                //const resultado = this.inventalista.filter( datos => datos.barraSku == codBarra );
                console.log('barra',resultado);
                if(resultado.length!=0){
                    const dataBarra = resultado[0];
                    this.verSku(dataBarra.iSku);
                    this.focusBarra();
                } else {
                    //console.log('Producto no Existe');
                    this.Msg='Producto no Existe'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                    this.focusBarra();
                };
            }
        },
        async searchBodegas(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+ this.contrato);
                const datos=response.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.listabodega.push({'id':element.ID,'nombre':element.Nombre})
                    });                
                }
            } catch (error) {
                console.log(error)               
            }
        },
        async buscarProducto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
            const datos=response.data;
            //console.log(datos);
            this.itemProductos=[];
            this.arrayProductos=[];
            this.inventalista=[];
            if (datos[0].existe=='si'){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.itemProductos.push(element.Nombre);
                    this.arrayProductos.push({sku:element.Sku,nameSku:element.Nombre,medida:element.Medida})                    
                    this.inventalista.push({'iSku':element.Sku,'iProducto':element.Nombre,'iMedida':element.Medida,'barraSku':element.Barra,});
                }
            }
        },
        handleInventa(line){
            this.verSku(line.iSku);
            this.d_inventa=false
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        clsInput(){
            this.disabledBodega=false;
            this.filledBodega=false;
            this.disabledSku=false;
            this.filledSku=false;
            this.disabledDatos=true;
            this.filledDatos=true;
            this.existe='';
            this.sku='';
            this.nombre='';
            this.categoria='';
            this.ncategoria=0;
            this.descripcion='';
            this.caracteristica='';
            this.cantidad='';
            this.bodega='';
            this.preciolocal='';
            this.observa=''
            this.movimiento='';
            this.tStock='';
            this.nStock=0;
            this.medida='';
            this.focusBarra();
        },
        async verSku(xSku){
            this.loading=true;
            try {
                if(xSku.trim()!=''){
                    this.disabledSku=true;
                    this.filledSku=true;
                    const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/producto/'+this.contrato+'/'+xSku);
                    const datos=response.data;
                    //console.log(datos);
                    if (datos[0].existe=='si'){
                        if(datos[0].Estado=='V'){
                            this.existe='si';
                            this.sku=datos[0].Sku;
                            this.nombre=datos[0].Nombre;
                            this.ncategoria=datos[0].Categoria;
                            this.descripcion=datos[0].Descripcion;
                            this.caracteristica=datos[0].Caracteristica;
                            this.preciolocal=datos[0].PrecioLocal;
                            this.medida=datos[0].Medida;
                            await this.nombreCategoria(this.ncategoria)
                            this.restoDatos(false);
                        } else {
                            this.Msg='Producto no vigente'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } else {
                        this.Msg='SKU no Existe';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                } else {
                    this.Msg='Ingrese SKU';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }                
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async nombreCategoria(numeroCategoria){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/'+ this.contrato);
            const datos=response.data;
            //console.log(datos);
            datos.forEach(element => {
                if(element.ID==numeroCategoria){
                    this.categoria=element.Nombre
                }
            });
        },
        async saveStock(){
            try {
                var correcto='si';
                if(!isNaN(this.cantidad)){
                    this.cantidad=this.cantidad;
                } else {
                    this.cantidad='';
                };
                if(this.bodega!='' && this.cantidad!='' && this.movimiento!=''){
                    if(this.movimiento=='Egreso' && parseFloat(this.cantidad)>parseFloat(this.nStock)){
                        correcto='no';
                    }
                    if(correcto=='si'){
                        if(parseFloat(this.cantidad)!=0){
                            var signo = '';
                            if(this.movimiento=='Ingreso'){signo='0+'};
                            if(this.movimiento=='Egreso'){signo='0-'};
                            var parametros={
                                'contrato': this.contrato,
                                'sku': this.sku,
                                'cantidad': this.cantidad,
                                'signo': signo,
                                'bodega': this.bodega,
                                'usuario':this.usu,
                                'observa':this.observa,
                                'origen':this.movimiento
                            };
                            //grabamos stock
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/stock',parametros);
                            const datos=response.data;
                            if (datos!='si'){
                                this.Msg='Inconsistencia al grabar Datos';
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            } else {
                                this.Msg= this.movimiento + ' de Producto Exitoso';
                                this.msgbox=true;
                                this.color='success';
                                this.showSnack();
                                this.disabledDatos=true;
                            }
                        } else {
                            this.Msg= 'Cantidad 0';
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                            this.disabledDatos=true;
                        }
                    } else {
                        this.Msg='Revisar Stock';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                } else {
                    this.Msg='Falta dato obligatorio'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }        
            } catch (error) {
                console.log(error)
            }
        },
        restoDatos(bool){
            this.disabledDatos=bool,
            this.filledDatos=bool
        },
        onlyNumber ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        async totalStock(id){
            this.nStock=0;
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/stock/bodegas/producto/total/'+ this.contrato +'/'+ id + '/' + this.sku);
            const datos=response.data;
            if (datos[0].existe=='si'){ 
                this.tStock='Total Stock:'+datos[0].Total;
                this.nStock=datos[0].Total;
            }
            if (datos[0].existe=='no'){ 
                this.tStock='Sin Stock';
            } 
            if (datos[0].existe=='error'){ 
                this.tStock='Error de Stock';
            } 
        }
    }
}
</script>